import styled from 'styled-components'
import { InputGroup, FormControl } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

const Container = styled.div`
  box-shadow: none !important;

  .input-group-addon {
    background-color: #ebf0f1;
    border-color: #ebf0f1;
    color: var(--main-color);
    min-width: 35px;
    padding: 6px 10px;
  }
  .form-control {
    background: #f8f8f8;
    border-color: #ebf0f1;
    color: var(--main-color);
  }

  .form-control:focus {
    border-color: #ebf0f1;
  }
  .form-control::placeholder {
    color: var(--main-color);
  }
`
const Input = ({
  handleChange,
  value,
  icon,
  isFetching,
  readOnly,
  placeholder,
  name
}) => (
  <Container>
    <InputGroup>
      <InputGroup.Addon>
        {isFetching && <FontAwesome name="spinner" spin />}
        {!isFetching && <FontAwesome name={icon} />}
      </InputGroup.Addon>
      <FormControl
        autoFocus
        type="text"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        readOnly={readOnly}
        name={name}
      />
    </InputGroup>
  </Container>
)

export default Input
